var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Title } from "shared/lib/designSystem";
import sizes from "shared/lib/designSystem/sizes";
import useScreenSize from "shared/lib/hooks/useScreenSize";
import { activityFilters, sortByList } from "./types";
import FilterDropdown from "shared/lib/components/Common/FilterDropdown";
var Header = styled(Title)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 18px;\n  margin-right: 24px;\n\n  @media (max-width: ", "px) {\n    width: 100%;\n    margin-bottom: 16px;\n  }\n"], ["\n  font-size: 18px;\n  margin-right: 24px;\n\n  @media (max-width: ", "px) {\n    width: 100%;\n    margin-bottom: 16px;\n  }\n"])), sizes.sm);
var VaultActivityHeader = function (_a) {
    var activityFilter = _a.activityFilter, setActivityFilter = _a.setActivityFilter, sortBy = _a.sortBy, setSortBy = _a.setSortBy;
    var width = useScreenSize().width;
    return (_jsxs("div", __assign({ className: "d-flex flex-wrap align-items-center flex-wrap w-100 mb-4" }, { children: [_jsx(Header, { children: "Vault Activity" }, void 0), _jsx(FilterDropdown
            // @ts-ignore
            , { 
                // @ts-ignore
                options: activityFilters, value: activityFilter, 
                // @ts-ignore
                onSelect: setActivityFilter, dropdownMenuConfig: {
                    horizontalOrientation: width > sizes.md ? "right" : "left",
                    topBuffer: 8,
                } }, void 0), _jsx(FilterDropdown
            // @ts-ignore
            , { 
                // @ts-ignore
                options: sortByList, value: sortBy, 
                // @ts-ignore
                onSelect: setSortBy, className: "ml-3" }, void 0)] }), void 0));
};
export default VaultActivityHeader;
var templateObject_1;
//# sourceMappingURL=VaultActivityHeader.js.map